import { IsNotEmpty, Matches } from 'class-validator';
import { TenantRoleType } from '../../../Enums';
import { FormDataBase } from '@/common/form';

export class UserDetailsFormDataUserEdit extends FormDataBase {

  email: string = '';

  @Matches(/^[a-zA-Z-' ]{1,50}$/, { message: 'Invalid first name. Valid characters are letters A-Z, \' (apostrophe) and - (hyphen).' })
  @IsNotEmpty({ message: 'First name is required' })
  firstName: string = '';

  @Matches(/^[a-zA-Z-' ]{1,50}$/, { message: 'Invalid last name. Valid characters are letters A-Z, \' (apostrophe) and - (hyphen).' })
  @IsNotEmpty({ message: 'Last name is required' })
  lastName: string = '';

  role: TenantRoleType = TenantRoleType.TenancyAdministrator;

}
